// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"5349a043","452":"82e95ba5","453":"6a349ed9","503":"a367b8b9","714":"da48ab56","749":"f92589a9","754":"1459ea4e","780":"ea070de8","798":"b2bfe0be","799":"f66361fc","861":"28da4535","952":"23c7953c"}[chunkId] + ".chunk.js";
};